import React, { useEffect, useState, useRef } from 'react'
import CommunityItem from './CommunityItem'
import Dialog from '../../../../../lib/Dialog'
import general, { redux } from '../../../../../general'
import { Link } from "react-router-dom";
import { useMount, useScroll } from 'ahooks';
import $ from "jquery";

export default function CommunityList(props) {

  const [loading, setLoading] = useState(false)
  const [communityList, setCommunityList] = useState([])
  const [page, setPage] = useState(1)
  const [more, setMore] = useState(false)
  const [init, setInit] = useState(false)
  const isfootMark = props.isfootMark

  const [currentVideoIndex, setCurrentVideoIndex] = useState(null);
  const videoRefs = useRef([]); // Player 实例数组（用于全局暂停）

  // 播放指定视频的函数（不变）
  const playVideo = (index) => {
    const currentPlayer = videoRefs.current[index];
    if (currentPlayer) {
      // 暂停所有其他 Player
      videoRefs.current.forEach((player, i) => {
        if (player && i !== index) {
          player.pause();
          player.seek(0); // 可选：重置到开头
        }
      });
      // 播放当前 Player
      currentPlayer.play()
      setCurrentVideoIndex(index);
    }
  };

  // 为每个 Player 创建 ref 的回调函数（简化）
  const setVideoRef = (index) => (element) => {
    if (element && !videoRefs.current[index]) {
      videoRefs.current[index] = element;
    }
  };

  const getCommunityList = (params = {}) => {
    if (loading) {
      return
    }
    setLoading(true)
    if (params.loading) {
      Dialog.loading()
    }
    let tmp = {
      circles_type: props.circles_type,
      sort: props.sort,
      tagid: props.tagid,
      topic_id: isfootMark ? '' : props.topic_id,
      uid: isfootMark ? props.user.member_id : '',
      search_info: props.search ?? '',
      pagination: { page: page, count: '10' },
      footprint_type: props.footprint_type ?? ''
    }
    if (params.page) {
      tmp.pagination = { page: params.page, count: '10' }
    }
    // console.log('tmp',tmp);
    general.axios.post(isfootMark ? '/getFootMarkList' : '/getCommunityList', tmp)
      .finally(() => {
        setLoading(false)
        if (params.loading) {
          Dialog.close()
        }
      })
      .then(res => {
        let { status, data } = res.data;
        if (!status.succeed) {
          Dialog.error(status.error_desc);
        } else {
          setInit(true)
          params.page && setPage(params.page);
          const community_list = isfootMark ? data.list : data.community_list
          setCommunityList(communityList => params.page === 1 || !params.page ? community_list : [...communityList, ...community_list])
          setMore(data.paginated.more);
          if (props.init) {
            props.init()
          }
        }
      })
  }

  useEffect(() => {
    if (props.topic_id && props.active) {
      getCommunityList({ page: 1, loading: true })
    }
  }, [props.topic_id])

  useEffect(() => {
    if (props.tagidActiveIndex && props.active) {
      getCommunityList({ page: 1, loading: true })
      scrollToTop()
    }
  }, [props.tagidActiveIndex])

  useEffect(() => {
    if (props.sort && props.active && init) {
      getCommunityList({ page: 1, loading: true })
      scrollToTop()
    }
  }, [props.sort])

  const mainDiv = document.querySelector('.main-community-item-content')
  const div = document.querySelector('.community-item-content')

  const scroll = props.isMainCommunity ? useScroll(mainDiv) : useScroll(div)
  useEffect(() => {
    
    if (props.active && init) {
      if (scroll.top < -50) {
        getCommunityList({ page: 1, loading: true })
      }
      if (isfootMark) {
        if (scroll.top + window.innerHeight + 20 > $(document).height() && more) {
          getCommunityList({ page: page + 1, loading: true })
        }
      } else {
        if (props.isMainCommunity) {
          if (scroll.top
            + $(document.querySelector('.game-info')).height()
            + $(document.querySelector('.community-item-content-buttons')).height()
            + $(document.querySelector('.community-item-activity')).height()
            + $(document.querySelector('.main-community-item-tabs')).height() + 120
            > $(document.querySelector('.main-community-item-list')).height() && more) {
            getCommunityList({ page: page + 1, loading: true })
          }
        } else {
          if (scroll.top
            + $(document.querySelector('.game-info')).height()
            + $(document.querySelector('.community-item-content-buttons')).height()
            + $(document.querySelector('.community-item-activity')).height()
            + $(document.querySelector('.community-item-tabs')).height() + 420
            > $(document.querySelector('.community-item-list')).height() && more) {
            getCommunityList({ page: page + 1, loading: true })
          }
        }
      }
    }
  }, [scroll, init])

  useEffect(() => {
    if (isfootMark && !init && props.active) {
      getCommunityList({ page: 1, loading: true })
    }
  }, [isfootMark, init]);

  useEffect(() => {
    if (props.footMarkActiveIndex && props.active) {
      getCommunityList({ page: 1, loading: true })
    }
  }, [props.footMarkActiveIndex])

  useEffect(() => {
    if (props.active) {
      if (localStorage.getItem('cache_community_publish_topicid')) {
        localStorage.removeItem('cache_community_publish_topicid');
        getCommunityList({ page: 1 })
      }
    }
  }, [props.active]);

  useEffect(() => {
    redux.subscribe(() => {
      const state = redux.getState();
      if (state.deleteCommunityItemId) {
        setCommunityList((communityList) =>
          communityList.filter((item) => item.id !== state.deleteCommunityItemId)
        );
      }
    });
  }, []);

  useEffect(() => {
    if (props.active) {
      redux.subscribe(() => {
        const state = redux.getState();
        if (state.updateUserTopItemId) {
          getCommunityList({ page: 1 });
          scrollToTop()
        }
      });
    }
  }, [props.active]);

  const scrollToTop = () => {
    setTimeout(() => {
      const div = document.getElementsByClassName('main-community-item-content')[0]
      div.scrollTo({
        top: 0,
        behavior: 'smooth' // 'smooth' 实现平滑滚动，'auto' 实现瞬间滚动
      });
    }, 300);
  }

  return (
    <>
      {communityList?.length === 0 && init ? <div className="empty"><img src="/resources/empty.png" alt="" />暂无数据</div> : null}
      {communityList?.map((item, index) => {
        return <Link key={item.id + index} to={'/communityDetail?id=' + (parseInt(item.recover) === 2 ? item.community_id : item.id) + '&tagid=' + item.tagid + '&circles_type=' + item.circles_type + '&topic_id=' + item.maiyou_gameid}>
          <CommunityItem
            item={item}
            tagid={props.tagid}
            index={index}
            currentVideoIndex={currentVideoIndex}
            onPlayVideo={playVideo}
            setVideoRef={setVideoRef}
            isfootMark={isfootMark}></CommunityItem>
        </Link>
      })}
      {communityList?.length > 0 && !more ? <div className="view-end">别撩啦！已经到底啦~</div> : null}
    </>
  )
}
